class NeboRingSizeChart {
  constructor(section) {
    this.section = section;
    this.wrapper = section.querySelector('[data-ring-table-wrap]');

    this.table = section.querySelector(
      '[data-ring-table-wrap] .nebo-ring-chart__table'
    );

    this.progressBar = section.querySelector(
      '[data-ring-progress]'
    );

    this.leftButtons = section.querySelectorAll(
      '[data-ring-scroll-left]'
    );

    this.rightButtons = section.querySelectorAll(
      '[data-ring-scroll-right]'
    );

    this.stickyHeader = section.querySelector(
      '[data-ring-sticky-header]'
    );

    this.stickyViewport = section.querySelector(
      '[data-ring-sticky-viewport]'
    );

    if (
      !this.wrapper ||
      !this.table ||
      !this.progressBar ||
      this.leftButtons.length === 0 ||
      this.rightButtons.length === 0
    ) {
      return;
    }

    this.createStickyHeader();

    this.handleScroll = this.update.bind(this);
    this.handleResize = this.update.bind(this);
    this.handlePageScroll =
      this.updateStickyVisibility.bind(this);

    this.wrapper.addEventListener(
      'scroll',
      this.handleScroll,
      { passive: true }
    );

    window.addEventListener(
      'scroll',
      this.handlePageScroll,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      this.handleResize
    );

    this.leftButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.scroll(-1);
      });
    });

    this.rightButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.scroll(1);
      });
    });

    this.update();
  }

  createStickyHeader() {
    if (!this.stickyHeader || !this.stickyViewport) {
      return;
    }

    const existingClone =
      this.stickyViewport.querySelector(
        '.nebo-ring-chart__table'
      );

    if (existingClone) {
      this.stickyTable = existingClone;

      if (this.stickyHeader.parentElement !== document.body) {
        document.body.appendChild(this.stickyHeader);
      }

      return;
    }

    const clonedTable = this.table.cloneNode(false);
    const colgroup = this.table.querySelector('colgroup');
    const thead = this.table.querySelector('thead');

    if (colgroup) {
      clonedTable.appendChild(colgroup.cloneNode(true));
    }

    if (thead) {
      clonedTable.appendChild(thead.cloneNode(true));
    }

    clonedTable.removeAttribute('aria-describedby');
    clonedTable.setAttribute('aria-hidden', 'true');

    this.stickyViewport.appendChild(clonedTable);
    this.stickyTable = clonedTable;

    document.body.appendChild(this.stickyHeader);
  }

scroll(direction) {
  const maximumScroll =
    this.wrapper.scrollWidth - this.wrapper.clientWidth;

  const distance = this.wrapper.clientWidth * 0.78;

  const targetScroll = Math.min(
    maximumScroll,
    Math.max(
      0,
      this.wrapper.scrollLeft + distance * direction
    )
  );

  const previousScroll = this.wrapper.scrollLeft;

  try {
    this.wrapper.scrollTo({
      left: targetScroll,
      behavior: 'smooth'
    });
  } catch (error) {
    this.wrapper.scrollLeft = targetScroll;
  }

  /*
    Резервный вариант для мобильных браузеров,
    которые принимают scrollTo(), но не выполняют его.
  */
  window.setTimeout(() => {
    const didNotMove =
      Math.abs(this.wrapper.scrollLeft - previousScroll) < 1;

    if (didNotMove && targetScroll !== previousScroll) {
      this.wrapper.scrollLeft = targetScroll;
    }

    this.update();
  }, 150);
}

  update() {
    const maximumScroll =
      this.wrapper.scrollWidth -
      this.wrapper.clientWidth;

    const currentScroll = Math.max(
      0,
      this.wrapper.scrollLeft
    );

    const progress =
      maximumScroll > 0
        ? (currentScroll / maximumScroll) * 100
        : 100;

    this.progressBar.style.width = `${progress}%`;

    const isAtStart = currentScroll <= 1;

    const isAtEnd =
      maximumScroll <= 0 ||
      currentScroll >= maximumScroll - 1;

    this.leftButtons.forEach((button) => {
      button.disabled = isAtStart;
    });

    this.rightButtons.forEach((button) => {
      button.disabled = isAtEnd;
    });

    this.syncStickyHeader();
    this.updateStickyVisibility();
  }

  syncStickyHeader() {
    if (!this.stickyHeader || !this.stickyTable) {
      return;
    }

    const wrapperRect =
      this.wrapper.getBoundingClientRect();

    const tableWidth = this.table.scrollWidth;

    const offsetValue = getComputedStyle(this.section)
      .getPropertyValue(
        '--nebo-ring-chart-sticky-offset'
      );

    const stickyOffset =
      Number.parseFloat(offsetValue) || 0;

    this.stickyHeader.style.top =
      `${stickyOffset}px`;

    this.stickyHeader.style.left =
      `${wrapperRect.left}px`;

    this.stickyHeader.style.width =
      `${wrapperRect.width}px`;

    this.stickyTable.style.width =
      `${tableWidth}px`;

    this.stickyTable.style.minWidth =
      `${tableWidth}px`;

    this.stickyTable.style.transform =
      `translate3d(${-this.wrapper.scrollLeft}px, 0, 0)`;
  }

  updateStickyVisibility() {
    if (
      !this.stickyHeader ||
      !this.stickyTable ||
      !this.table ||
      !this.wrapper
    ) {
      return;
    }

    const originalHeader =
      this.table.querySelector('thead');

    const clonedHeader =
      this.stickyTable.querySelector('thead');

    if (!originalHeader || !clonedHeader) {
      return;
    }

    const headerRect =
      originalHeader.getBoundingClientRect();

    const tableRect =
      this.table.getBoundingClientRect();

    const offsetValue = getComputedStyle(this.section)
      .getPropertyValue(
        '--nebo-ring-chart-sticky-offset'
      );

    const stickyOffset =
      Number.parseFloat(offsetValue) || 0;

    const stickyHeight =
      clonedHeader.getBoundingClientRect().height;

    const originalHeaderPassed =
      headerRect.top <= stickyOffset;

    const tableStillVisible =
      tableRect.bottom >
      stickyOffset + stickyHeight;

    const wrapperVisible =
      tableRect.right > 0 &&
      tableRect.left < window.innerWidth;

    const shouldShow =
      originalHeaderPassed &&
      tableStillVisible &&
      wrapperVisible;

    this.stickyHeader.classList.toggle(
      'is-visible',
      shouldShow
    );

    if (shouldShow) {
      this.syncStickyHeader();
    }
  }
}

function initializeNeboRingSizeCharts(
  container = document
) {
  const sections = container.querySelectorAll(
    '[data-nebo-ring-size-chart]:not([data-nebo-ring-size-chart-initialized])'
  );

  sections.forEach((section) => {
    section.setAttribute(
      'data-nebo-ring-size-chart-initialized',
      'true'
    );

    new NeboRingSizeChart(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      initializeNeboRingSizeCharts();
    }
  );
} else {
  initializeNeboRingSizeCharts();
}

document.addEventListener(
  'shopify:section:load',
  (event) => {
    initializeNeboRingSizeCharts(event.target);
  }
);